import { FilterSectionData } from "@shared/features/filters/types";
import Text from "common/Typography/Text";
import React from "react";
import styled from "styled-components";
import Switch from "common/Buttons/Switch";
import {
  BooleanFilterType,
  FilterType,
  LanguageNameSpaces,
} from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { getNewLookChipColors } from "common/Filters/common/styles";

const BooleanFiltersSection = ({
  onChange,
  value,
  title,
  isChipsView,
  filterType,
  isSingleRowView,
  getChipsText,
}: FilterSectionData<BooleanFilterType>) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  let optionDisplay = title;
  if (filterType === FilterType.IS_HOT) {
    if (isChipsView && isSingleRowView) {
      optionDisplay = getChipsText();
    } else if (filterType === FilterType.IS_HOT) {
      optionDisplay = `${
        isChipsView ? t("filters.titles.only") : t("filters.titles.show_only")
      } ${title}`;
    }
  } else if (filterType === FilterType.VALID_BOT_AMOUNT) {
    optionDisplay = t("filters.toggles.hide_insufficient_funds");
  }

  return (
    <Wrapper
      onClick={() => onChange(!value)}
      $isChipsView={isChipsView}
      $isSingleRowView={isSingleRowView}
      style={{ padding: isChipsView ? "0 10px" : "4px 0 6px 0" }}
    >
      <Text style={{ marginRight: isSingleRowView ? 6 : 12 }}>
        {optionDisplay}
      </Text>
      <Switch checked={value} size={isChipsView ? "small" : "default"} />
    </Wrapper>
  );
};

export default BooleanFiltersSection;

const Wrapper = styled.div<{
  $isChipsView?: boolean;
  $isSingleRowView?: boolean;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  ${(p) =>
    p.$isChipsView &&
    `
    background: ${p.theme.colors.cardBgColor};
    border: ${p.theme.borders.light};
    height: 32px;
    padding: 0 12px;
    border-radius: 6px;
    width: 100%;
    white-space: nowrap;
  `}
  ${(p) =>
    p.$isSingleRowView &&
    `
     background: ${p.theme.colors.filterChipsColor};
     border: none;
     border-radius: 50px;
  `}
  ${(p) =>
    p.$isSingleRowView &&
    p.theme.isNewLook &&
    `
     background: ${getNewLookChipColors(p.theme).background};
     border: ${getNewLookChipColors(p.theme).border};
     border-radius: ${p.theme.radii.control}px;
     color: ${p.theme.colors.titleColor};
     font-size: 13px;
  `}
`;
